import Phaser from 'phaser'

export class RubikText extends Phaser.GameObjects.Text {
	constructor(
		scene: Phaser.Scene,
		x: number,
		y: number,
		text?: string | string[],
		style?: Phaser.Types.GameObjects.Text.TextStyle
	) {
		super(scene, x, y, text, {
			...{
				fontFamily: "'Rubik', Inter, system-ui, Avenir, Helvetica, Arial, sans-serif",
				fontSize: '18px',
				color: '#ffffff',
			},
			...style,
		})
		this.setResolution(3)
		scene.add.existing(this)
	}
}
